import React from 'react';
import { useT } from '../../i18n/LocaleContext';
import { useData } from '../../data/DataContext';
import { formatCurrency, payerLabel } from '../../utils/format';
import Badge from '../ui/Badge';
import EmptyState from '../ui/EmptyState';
import { useLocale } from '../../i18n/LocaleContext';

const TYPE_TONE = { cotisation: 'cotisation', pelerinage: 'pelerinage', offrande: 'offrande' };
const STATUS_TONE = { paid: 'paid', pending: 'pending', cancelled: 'inactive', refunded: 'completed' };

export default function RecentPayments({ payments }) {
  const t = useT();
  const { locale } = useLocale();
  const { memberById } = useData();

  if (!payments || payments.length === 0) {
    return <EmptyState title={t('payments.empty_title')} body={t('payments.empty_body')} />;
  }

  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            <th>{t('common.reference')}</th>
            <th>{t('payments.field_member')}</th>
            <th>{t('payments.field_type')}</th>
            <th>{t('payments.field_amount')}</th>
            <th>{t('payments.field_status')}</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((p) => (
            <tr key={p.id}>
              <td className="mono">{p.code || p.id}</td>
              <td>{payerLabel(p, memberById)}</td>
              <td><Badge tone={`${TYPE_TONE[p.type] || 'cotisation'}`}>{t(`payments.types.${p.type}`)}</Badge></td>
              <td><strong>{formatCurrency(p.amount, locale)}</strong></td>
              <td><Badge tone={`${STATUS_TONE[p.status] || 'pending'}`}>{t(`payments.statuses.${p.status}`)}</Badge></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
